// Centrale Nederlandse auth-teksten. Eén bron zodat UX-copy consistent blijft.

export const SESSIE_VERLOPEN = "Je sessie is verlopen. Meld je opnieuw aan.";
export const AUTH_VEREIST = "Authenticatie vereist. Meld je aan om verder te gaan.";
export const GEEN_TOEGANG_PAGINA = "Je hebt geen toegang tot deze pagina.";
export const GEEN_TOEGANG_APP = "Je account heeft geen toegang tot deze applicatie.";
export const AANMELDEN_MISLUKT_LOOP =
  "Aanmelden lukt niet. Mogelijk heeft je account geen toegang. Meld je af en probeer een ander account.";
// Technische fout (netwerk, timeout, 5xx, token nog niet beschikbaar): herstelbaar
// en nadrukkelijk GEEN uitspraak over rechten. Nooit GEEN_TOEGANG_APP hiervoor
// gebruiken: die vermenging maakte een tijdelijke storing zichtbaar als weigering.
export const AUTH_CONTROLE_MISLUKT =
  "We konden je toegang niet controleren. Controleer je verbinding en probeer opnieuw.";
export const OPNIEUW_PROBEREN = "Opnieuw proberen";

// Hint-teksten voor apiClient foutmeldingen (voorheen Engels).
export const HINT_401 = "Niet aangemeld. Meld je opnieuw aan.";
export const HINT_403 = "Toegang geweigerd.";
export const HINT_502 =
  "De market data engine is niet bereikbaar. Probeer het later opnieuw of controleer of de engine draait.";
export const HINT_5XX = "Interne serverfout. Probeer het later opnieuw.";

// Issue #23: aangemeld, maar nog geen toewijzing (wachtpagina in plaats van terug naar de login).
export const WACHT_OP_TOEGANG = "Je hebt nog geen toegang. Beheer ziet je aanvraag.";
export const TOEWIJZING_NIET_ACTIEF =
  "Je hebt een toewijzing, maar die geeft in deze versie nog geen toegang tot de app. Beheer kan ze aanvullen.";

// Rechten F2 (issue #23, spec §5): step-up. De server vraagt voor deze actie een extra bevestiging van de aanmelding
// (Entra authentication context, bv. MFA); de webapp vraagt via MSAL een nieuw token en herhaalt de actie één keer.
export const STEP_UP_MISLUKT =
  "Deze actie vraagt een extra bevestiging van je aanmelding (bv. MFA), maar die is niet gelukt. Sta pop-ups toe voor deze site en probeer opnieuw.";
export const STEP_UP_GEWEIGERD =
  "Ook na de extra bevestiging van je aanmelding weigert de server deze actie. Meld je af en opnieuw aan, of vraag Beheer om het na te kijken.";
// Step-up "opnieuw aanmelden" (STEPUP_MODE=reauth, beslissing 04-11-2026: geen Entra ID P1): voor een gevoelige actie vraagt
// de server een recente aanmelding; de webapp opent het aanmeldvenster (pop-up) en herhaalt de actie één keer.
export const HERAANMELDEN_AFGEBROKEN =
  "Je hebt het opnieuw aanmelden afgebroken. Deze actie is niet uitgevoerd; probeer opnieuw en meld je aan om ze te bevestigen.";
export const HERAANMELDEN_MISLUKT =
  "Deze actie vraagt dat je je opnieuw aanmeldt, maar dat is niet gelukt. Er is niets uitgevoerd. Sta pop-ups toe voor deze site en probeer opnieuw.";
export const HERAANMELDEN_GEWEIGERD =
  "Ook nadat je je opnieuw aanmeldde, weigert de server deze actie. Er is niets uitgevoerd. Vraag Beheer om het na te kijken.";
// 403 met reden niveau of activatie: geen doorverwijzing naar de weigerpagina, de melding blijft bij de knop.
export const NIVEAU_TE_LAAG = "Je niveau in deze rol volstaat niet voor deze actie.";
export const ACTIVATIE_NODIG = "Activeer eerst je rol (knop Activeren in je accountmenu) en probeer opnieuw.";
